import React, { useEffect, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
type FAQItemProps = {
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  toggleOpen: () => void;
};
const FAQItem = ({
  question,
  answer,
  isOpen,
  toggleOpen
}: FAQItemProps) => {
  return <div className="border-b border-gray-200 py-5" data-id="element-1428">
      <button className="flex w-full justify-between items-center text-left" onClick={toggleOpen} data-id="element-1429">
        <h3 className="text-lg font-medium text-navy-900" data-id="element-1430">{question}</h3>
        <span className="ml-6 flex-shrink-0" data-id="element-1431">
          {isOpen ? <ChevronUpIcon className="h-5 w-5 text-navy-800" data-id="element-1432" /> : <ChevronDownIcon className="h-5 w-5 text-navy-800" data-id="element-1433" />}
        </span>
      </button>
      {isOpen && <div className="mt-3 pr-12" data-id="element-1434">
          <div className="text-base text-gray-600" data-id="element-1435">{answer}</div>
        </div>}
    </div>;
};
export const FAQSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('faq');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const faqs = [{
    question: 'What do early members get?',
    answer: "Early teachers get full access to MaestroConnect's professional teaching tools at early pricing and can help shape the platform through feedback as new features are developed."
  }, {
    question: 'How do you verify teachers?',
    answer: 'Teachers create professional profiles with their experience, instruments, and teaching details. Accounts are secured through email verification, and additional verification features may be introduced as the platform evolves.'
  }, {
    question: 'How do payments work during early access?',
    answer: 'During early access, teachers manage payment arrangements directly with their students. Integrated payment and booking tools are planned as the platform evolves.'
  }, {
    question: 'Can I teach both online and in-person?',
    answer: 'Yes. Teachers can offer online lessons, in-person lessons, or both, with full control over availability and scheduling preferences.'
  }, {
    question: 'Is MaestroConnect available worldwide?',
    answer: 'MaestroConnect is launching with support for teachers in select regions. Availability will expand over time as payment and compliance support is added in additional countries.'
  }, {
    question: 'Can teachers cancel anytime?',
    answer: 'Yes. Teachers can cancel their subscription at any time. There are no long-term contracts or hidden fees.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-24 bg-gray-50" data-id="element-1436">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1437">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1438">
          <div className="text-center mb-16" data-id="element-1439">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-1440">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1441">
              Everything you need to know about MaestroConnect
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-1442">
            <div className="divide-y divide-gray-200" data-id="element-1443">
              {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} toggleOpen={() => toggleFAQ(index)} data-id="element-1444" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};